import * as React from "react";
import { DataSearch, MultiDropdownList, DateRange, SelectedFilters } from "@appbaseio/reactivesearch";
import { componentIds } from "./utils";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "../../../helperComponents/Elasticsearch/elasticsearch.scss";

var SearchInputs = function SearchInputs() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(DataSearch, {
    className: "col-md-4 elasticsearch-component",
    componentId: "claim_id",
    dataField: ["claim_number", "poliza.code", "poliza.asegurado.full_name", "poliza.asegurado.rut"],
    queryFormat: "and",
    fuzziness: 2,
    title: "N\xBA de Siniestro, N\xBA p\xF3liza, Asegurado",
    placeholder: "N\xBA de Siniestro, N\xBA p\xF3liza, Asegurado",
    autosuggest: false // somehow it crashes with this
    ,
    react: {
      and: componentIds("claim_id")
    }
  }), /*#__PURE__*/React.createElement(MultiDropdownList, {
    className: "col-md-4 elasticsearch-component",
    componentId: "status",
    dataField: "status_translated.keyword",
    sortBy: "count",
    showCount: true,
    showMissing: true,
    showFilter: true,
    placeholder: "Selecciona un estado",
    filterLabel: "Estado Siniestro",
    title: "Estado Siniestro",
    URLParams: false,
    loader: ".",
    react: {
      and: componentIds("status")
    }
  }), /*#__PURE__*/React.createElement(MultiDropdownList, {
    className: "col-md-4 elasticsearch-component",
    componentId: "poliza_ramo",
    dataField: "poliza.ramo.keyword",
    sortBy: "count",
    showCount: true,
    showMissing: true,
    showFilter: true,
    filterLabel: "Ramo",
    placeholder: "Selecciona un ramo",
    title: "Ramo",
    URLParams: false,
    loader: ".",
    react: {
      and: componentIds("poliza_ramo")
    }
  }), /*#__PURE__*/React.createElement(DataSearch, {
    className: "col-md-4 elasticsearch-component",
    componentId: "coverage",
    dataField: ["coverage"],
    queryFormat: "and",
    fuzziness: 2,
    title: "Cobertura",
    placeholder: "Cobertura",
    autosuggest: false // somehow it crashes with this
    ,
    react: {
      and: componentIds("coverage")
    }
  }), /*#__PURE__*/React.createElement(DateRange, {
    componentId: "claim_date",
    className: "col-md-4 elasticsearch-component",
    dataField: "claim_date",
    title: "Fecha de Siniestro",
    placeholder: {
      start: "Inicio",
      end: "Termino"
    },
    numberOfMonths: 2,
    queryFormat: "date",
    autoFocusEnd: true,
    showClear: true,
    showFilter: true,
    filterLabel: "Fecha",
    dayPickerInputProps: {
      formatDate: formatDate,
      parseDate: parseDate,
      format: "DD/MM/YYYY",
      placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
      dayPickerProps: {
        locale: "es",
        localeUtils: MomentLocaleUtils
      }
    },
    react: {
      and: componentIds()
    }
  }), /*#__PURE__*/React.createElement(DateRange, {
    componentId: "request_date",
    className: "col-md-4 elasticsearch-component",
    dataField: "request_date",
    title: "Fecha de Denuncia",
    placeholder: {
      start: "Inicio",
      end: "Termino"
    },
    numberOfMonths: 2,
    queryFormat: "date",
    autoFocusEnd: true,
    showClear: true,
    showFilter: true,
    filterLabel: "Fecha",
    dayPickerInputProps: {
      formatDate: formatDate,
      parseDate: parseDate,
      format: "DD/MM/YYYY",
      placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
      dayPickerProps: {
        locale: "es",
        localeUtils: MomentLocaleUtils
      }
    },
    react: {
      and: componentIds()
    }
  }), /*#__PURE__*/React.createElement(MultiDropdownList, {
    className: "col-md-4 elasticsearch-component",
    componentId: "company",
    dataField: "poliza.company.name.keyword",
    queryFormat: "and",
    sortBy: "count",
    showCount: true,
    showMissing: true,
    showFilter: true,
    filterLabel: "Compa\xF1\xEDa",
    placeholder: "Selecciona una compa\xF1\xEDa",
    title: "Compa\xF1\xEDa",
    URLParams: false,
    loader: ".",
    react: {
      and: componentIds("company")
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(SelectedFilters, {
    className: "elasticsearch-component",
    showClearAll: true,
    clearAllLabel: "Limpiar filtros"
  })));
};

export default SearchInputs;